// extracted by mini-css-extract-plugin
export default {"rounded-circle":"UserProfileDropdown_rounded-circle__2Zoci","user-profile-dropdown":"UserProfileDropdown_user-profile-dropdown__7L9co"};